import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrashCan, faGrip,faBarcode } from "@fortawesome/free-solid-svg-icons";
import { Dropdown,Menu } from "antd";
//Rack Table Config
export const RackTableConfig = (configActions) => [
  {
    title: "Rack Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
  },
  {
    title: "PositionX",
    dataIndex: "positionX",
    key: "positionX",
  },
  {
    title: "PositionY",
    dataIndex: "positionY",
    key: "PositionY",
  },
  {
    title: "Width",
    dataIndex: "width",
    key: "width",
  },
  {
    title: "Height",
    dataIndex: "length",
    key: "length",
  },
  {
    title: "Unit",
    dataIndex: "unitType",
    key: "unitType",
  },
  {
    title: "Action",
    key: "operation",
    width: 90,
    render: (element) =>
      <div onClick={(e) => e.stopPropagation()} className="tableActions">
        <Dropdown 
          overlay={
            <Menu 
              style={{
                pointerEvents: 'auto',
                zIndex: 1000
              }}
            >
              <Menu.Item 
                key="1" 
                style={{
                  pointerEvents: 'auto'
                }}
                onClick={() => configActions.onChangeLabelType(element, 'BARCODE')}
              >
                BarCode
              </Menu.Item>
              <Menu.Item 
                key="2" 
                style={{
                  pointerEvents: 'auto'
                }}
                onClick={() => configActions.onChangeLabelType(element, 'QRCODE')}
              >
                QR Code
              </Menu.Item>
            </Menu>
          } 
          trigger={["click"]}
          overlayStyle={{
            pointerEvents: 'auto'
          }}
        >
          <FontAwesomeIcon icon={faBarcode} className="edit-icon" onClick={(e) =>e.stopPropagation()} />
        </Dropdown>
        {/* <FontAwesomeIcon icon={faGrip} className="edit-icon" onClick={() => configActions.onGenerateBins(element, "rack")}  /> */}
        <FontAwesomeIcon icon={faPencil} className="edit-icon" onClick={() => configActions.onEdit(element, "rack")} />
        {/* <FontAwesomeIcon icon={faTrashCan} className="tool-icon element-delete" onClick={() => configActions.onDeleteAction(element, "rack")} /> */}
      </div>
  },
];

//Wall Table Config
export const wallTableConfig = (configActions) => [
  {
    title: "Wall Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
  },
  {
    title: "PositionX",
    dataIndex: "positionX",
    key: "positionX",
  },
  {
    title: "PositionY",
    dataIndex: "positionY",
    key: "PositionY",
  },
  {
    title: "Width",
    dataIndex: "width",
    key: "width",
  },
  {
    title: "Height",
    dataIndex: "length",
    key: "length",
  },
  {
    title: "Unit",
    dataIndex: "unitType",
    key: "unitType",
  },{
    title: "Action",
    key: "operation",
    width: 90,
    render: (element) =>
      <div onClick={(e) => e.stopPropagation()} className="tableActions">
         <span onClick={console.log('wallElement =>',element)}></span>
         <FontAwesomeIcon icon={faPencil} className="edit-icon" onClick={() => configActions.onEdit(element, "wall")} />
         {/* <FontAwesomeIcon icon={faTrashCan} className="tool-icon element-delete" onClick={() => configActions.onDeleteAction(element, "wall")} /> */}
      </div>
  }
];

//Area Table Config
export const areaTableConfig = (configActions) => [
  {
    title: "Area Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
  },
  {
    title: "PositionX",
    dataIndex: "positionX",
    key: "positionX",
  },
  {
    title: "PositionY",
    dataIndex: "positionY",
    key: "PositionY",
  },
  {
    title: "Width",
    dataIndex: "width",
    key: "width",
  },
  {
    title: "Length",
    dataIndex: "length",
    key: "length",
  },
  {
    title: "Unit",
    dataIndex: "unitType",
    key: "unitType",
  },
 {
    title: "Action",
    key: "operation",
    width: 90,
    render: (element) =>
      <div onClick={(e) => e.stopPropagation()} className="tableActions">
        <Dropdown 
          overlay={
            <Menu 
              style={{
                pointerEvents: 'auto',
                zIndex: 1000
              }}
            >
              <Menu.Item 
                key="1" 
                style={{
                  pointerEvents: 'auto'
                }}
                onClick={() => configActions.onChangeLabelType(element, 'BARCODE')}
              >
                BarCode
              </Menu.Item>
              <Menu.Item 
                key="2" 
                style={{
                  pointerEvents: 'auto'
                }}
                onClick={() => configActions.onChangeLabelType(element, 'QRCODE')}
              >
                QR Code
              </Menu.Item>
            </Menu>
          } 
          trigger={["click"]}
          overlayStyle={{
            pointerEvents: 'auto'
          }}
        >
          <FontAwesomeIcon icon={faBarcode} className="edit-icon" onClick={(e) =>e.stopPropagation()} />
        </Dropdown>
        <FontAwesomeIcon icon={faPencil} className="edit-icon" onClick={() => configActions.onEdit(element, "area")} />
        {/* <FontAwesomeIcon icon={faTrashCan} className="tool-icon element-delete" onClick={() => configActions.onDeleteAction(element, "area")} /> */}
      </div>
 }
];

//Dock Table Config
export const dockTableConfig = (configActions) => [
  {
    title: "Dock Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
  },
  {
    title: "PositionX",
    dataIndex: "positionX",
    key: "positionX",
  },
  {
    title: "PositionY",
    dataIndex: "positionY",
    key: "PositionY",
  },
  {
    title: "Width",
    dataIndex: "width",
    key: "width",
  },
  {
    title: "Height",
    dataIndex: "length",
    key: "length",
  },
  {
    title: "Unit",
    dataIndex: "unitType",
    key: "unitType",
  },
  {
    title:"Action",
    key:"operation",
    width:90,
    render: (element) =>
      <div onClick={(e) => e.stopPropagation()} className="tableActions">
        <FontAwesomeIcon icon={faPencil} className="edit-icon" onClick={() => configActions.onEdit(element, "dock")} />
        {/* <FontAwesomeIcon icon={faTrashCan} className="tool-icon element-delete" onClick={() => configActions.onDeleteAction(element, "dock")} /> */}
      </div>
  }
];



//Bin Table Config
export const binTableConfig = (configActions) => [
  {
    title: "Bin Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Doc Location",
    dataIndex: "code",
    key: "code",
  },
   {
    title: "Labels",
    dataIndex: "labels",
    key: "labels",
    render: (labels) => labels.map((label) => label.name).join(", ") || "-",
  },
  {
    title: "Bin Height",
    dataIndex: "height",
    key: "height",
  },
  {
    title: "Bin Width",
    dataIndex: "width",
    key: "width",
  },
  {
    title: "Action",
    key: "operation",
    width: 90,
    render: (element) =>
      <div onClick={(e) => e.stopPropagation()} className="tableActions" >
        <Dropdown 
          overlay={
            <Menu 
              style={{
                pointerEvents: 'auto',
                zIndex: 1000
              }}
            >
              <Menu.Item 
                key="1" 
                style={{
                  pointerEvents: 'auto'
                }}
                onClick={() => configActions.onChangeLabelType(element, 'BARCODE')}
              >
                BarCode
              </Menu.Item>
              <Menu.Item 
                key="2" 
                style={{
                  pointerEvents: 'auto'
                }}
                onClick={() => configActions.onChangeLabelType(element, 'QRCODE')}
              >
                QR Code
              </Menu.Item>
            </Menu>
          } 
          trigger={["click"]}
          overlayStyle={{
            pointerEvents: 'auto'
          }}
        >
          <FontAwesomeIcon icon={faBarcode} />
        </Dropdown>
         <FontAwesomeIcon icon={faPencil} className="edit-icon" onClick={() => configActions.onEdit(element, "bin")} />
      </div>
  }
];



//SubArea Table Config
export const subAreaTableConfig = (configActions) => [
  {
    title: "SubArea Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
  },
  {
    title: "PositionX",
    dataIndex: "positionX",
    key: "positionX",
  },
  {
    title: "PositionY",
    dataIndex: "positionY",
    key: "PositionY",
  },
  {
    title: "Width",
    dataIndex: "width",
    key: "width",
  },
  {
    title: "height",
    dataIndex: "height",
    key: "height",
  },
  {
    title: "Unit",
    dataIndex: "unitType",
    key: "unitType",
  },
 {
    title: "Action",
    key: "operation",
    width: 90,
    render: (element) =>
      <div onClick={(e) => e.stopPropagation()} className="tableActions">
        <Dropdown 
          overlay={
            <Menu 
              style={{
                pointerEvents: 'auto',
                zIndex: 1000
              }}
            >
              <Menu.Item 
                key="1" 
                style={{
                  pointerEvents: 'auto'
                }}
                onClick={() => configActions.onChangeLabelType(element, 'BARCODE')}
              >
                BarCode
              </Menu.Item>
              <Menu.Item 
                key="2" 
                style={{
                  pointerEvents: 'auto'
                }}
                onClick={() => configActions.onChangeLabelType(element, 'QRCODE')}
              >
                QR Code
              </Menu.Item>
            </Menu>
          } 
          trigger={["click"]}
          overlayStyle={{
            pointerEvents: 'auto'
          }}
        >
          <FontAwesomeIcon icon={faBarcode} className="edit-icon" onClick={(e) =>e.stopPropagation()} />
        </Dropdown>
        <FontAwesomeIcon icon={faPencil} className="edit-icon" onClick={() => configActions.onEdit(element, "subArea")} />
        {/* <FontAwesomeIcon icon={faTrashCan} className="tool-icon element-delete" onClick={() => configActions.onDeleteAction(element, "subArea")} /> */}
      </div>
  },
];
